// ??? = Dinge, die nochmals überprüft werden sollten

const translations = {
  www: {
    common: {
      viewMore: 'View more',
      viewLess: 'View less',
      removeAllFilters: 'Remove all filters',
      filters: 'Filters',
      viewPlaces: 'No results | View 1 places | View {count} places',
      any: 'Any',
      min: 'Min',
      max: 'Max',
    },
    facets: {
      selected: 'Selected',
      country: 'Country',
      region: 'Region',
      place: 'Place',
      pax: 'Guests',
      minpets: 'Pets',
      priceRange: 'Price per stay',
      rooms: 'Rooms and facilities',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      accommodationType: 'Accommodation type',
      propertyType: 'Property type',
      starRating: 'Star rating',
      features: 'Features',
      distances: 'Distances',
      sea: 'Distance to sea',
      lake: 'Distance to lake',
      ski: 'Distance to ski slope / mountains',
      center: 'Nearest town / town center',
      publicTransport: 'Distance to public transportation',
      offers: 'Offers',
      holidayType: 'Type of holiday',
      special: 'Something special',
      pool: 'Swimming pool',
      fishing: 'Fishing holiday',
      activities: 'Activities in resort',
      freeweekCategory: 'Category',
    },
    search: {
      destination: {
        title: 'Destination',
        country: 'Country',
        region: 'Region',
        place: 'Place',
      },
      'min-price': 'Min',
      maxPrice: 'Max',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      pax: 'Guests',
      minpets: 'Pets',
      accommodationType: {
        house: 'Vacation house',
        apartment: 'Apartment',
      },
      propertyType: {
        villa: 'Villa',
        chalet: 'Chalet',
        farmhouse: 'Farmhouse',
        studio: 'Studio',
        detached: 'Detached house',
      },
      freeweekCategory: {
        freeweekCategoryA: 'Category A',
        freeweekCategoryB: 'Category B',
        freeweekCategoryC: 'Category C',
      },
      stars: 'Any | 1+ | 2+ | 3+ | 4+ | {count}',
      features: {
        pets: 'Pets',
        wlan: 'WiFi',
        aircondition: 'Air-conditioning',
        parking: 'Parking',
        garage: 'Garage',
        balconyOrTerrace: 'Balcony / Terrace',
        dishwasher: 'Dishwasher',
        washingmachine: 'Washing machine',
        tv: 'TV',
        seaOrLakeView: 'Sea or lake view',
        bbq: 'BBQ',
        boat: 'Boat',
        cots: 'Baby cot',
        hottub: 'Hot tub',
        fireplace: 'Fireplace',
        sauna: 'Sauna',
        wheelchair: 'Wheel chair',
        chargingStation: 'E-charging station',
      },
      distances: {
        0: '0 m',
        '100': '100m',
        '500': '500m',
        '1000': '1km',
        '2000': '2km',
        '5000': '5km',
        '10000': '10km',
      },
      offers: {
        specialOffer: 'Any special offer',
        lastMinute: 'Last minute',
        earlyBooker: 'Early booking discount',
      },
      holidayType: {
        familyfriendly: 'Family friendly',
        holidayResort: 'Holiday village',
        residence: 'Residence',
        citytrips: 'City trips',
      },
      special: {
        casa: 'Discover CASA',
        swissPeak: 'SWISSPEAK Resorts',
        workation: 'Workation',
        sustainable: 'Sustainability',
      },
      pool: {
        pool: 'Swimming Pool',
        poolPrivate: 'Private pool',
        poolIndoor: 'Indoor pool',
        poolChildren: 'Children pool',
      },
      fishing: {
        fishing: 'Fishing house',
      },
      activities: {
        skiing: 'Skiing / Snowboarding',
        hiking: 'Hiking',
        golfing: 'Golfing',
        cycling: 'Cycling',
        wellness: 'Wellness',
        tennis: 'Tennis',
        surfing: 'Surfing',
        sailing: 'Sailing',
        mountainbiking: 'Mountain-Biking',
        riding: 'Riding',
        crosscountryskiing: 'Cross country skiing',
      },
    },
    map: {
      viewMap: 'View map',
      type: {
        roadmap: 'Map',
        satellite: 'Satellite',
        hybrid: 'Hybrid',
        terrain: 'Terrain',
      },
    },
    components: {
      hitbox: {
        sustainabilityTooltip:
          'Dieses Ferienhaus erfüllt alle 24 Kriterien des Nachhaltigkeitssiegels',
        loveNatureTooltip:
          'Diese Unterkunft erfüllt mindestens 7 von 12 von Interhome definierten Kriterien zum Thema Umweltschutz.',
        bookmarkAdd: 'Merken',
        bookmarkDel: 'Gemerkt',
        location: 'Karte',
        Tags: {
          toprated: 'Top-Rated',
          new: 'Neu',
        },
        Features: {
          pax_s: 'keine Person | eine Person | {count} Personen',
          room_s: 'keine Zimmer | ein Zimmer | {count} Zimmer',
          bedroom_s:
            'keine Schlafzimmer | ein Schlafzimmer | {count} Schlafzimmer',
          bathroom_s: 'kein Bad | ein Bad | {count} Bäder',
        },
        Title: {
          type: {
            A: 'Ferienwohnung',
            H: 'Ferienhaus',
          },
        },
        Rating: {
          review_s:
            'Aktuell liegen uns noch keine Kundenbewertungen zu diesem Objekt vor | eine Bewertung | {count} Bewertungen',
          labels: {
            1: 'Mangelhaft',
            2: 'Befriedigend',
            3: 'Gut',
            4: 'Sehr gut',
            5: 'Ausgezeichnet',
          },
        },
        Price: {
          night_s: 'eine Nacht|{count} Nächte',
          from: 'ab',
          saved: 'Sie sparen {amount}',
          upToPax: 'bei Belegung bis {count} Pers.',
          addCosts: 'zuzüglich ggf. Nebenkosten',
          dependentPrice: 'Preis abhängig von Zeitraum und Personenzahl',
          priceAfterInput:
            'Ihr Mietpreis wird nach Eingabe der Anzahl Reisender sowie Ihres Reisezeitraumes angezeigt.',
          addCostsLong:
            'zuzüglich obligatorischer oder fakultativer Nebenkosten nach tatsächlicher Belegung beziehungsweise tatsächlichem Verbrauch',
          night: 'Nacht',
          total: 'Gesamt',
        },
        Gallery: {
          inside: 'Innenbereich',
          outside: 'Haus/Residenz',
          aerialPhotography: 'Luftaufnahme',
          bathroom: 'Badezimmer / Wellness',
          beach: 'Strand',
          bedroom: 'Schlafzimmer',
          community: 'Gemeinschaftsbereich',
          energyLabel: 'Energieausweis',
          floorplan: 'Grundriss',
          house: 'Haus',
          insideOther: 'Innenbereich',
          internal: 'Info / internes Bild',
          kitchen: 'Küche / Esszimmer',
          livingRoom: 'Wohnzimmer',
          mood: 'Stimmungsbild',
          outdoor: 'Aussenbereich',
          place: 'Ort',
          poolIndoor: 'Innenpool',
          poolOutdoor: 'Aussenpool',
          terrace: 'Terrasse',
          view: 'Aussicht',
        },
        discover: 'Entdecken',
      },
      site: {
        Header: {
          availability: 'Persönlich für Sie da!',
          popularDestinations: 'Beliebte Reiseziele',
          contactUs: 'Kontaktieren Sie uns',
          hereForYou: 'Wir sind für Sie da',
          faq: 'FAQ',
          labels: {
            favorites: 'Merkliste',
            language: 'Sprache',
            currency: 'Währung',
            menu: 'Menü',
          },

          user: {
            name: 'User',
            login: 'Sign in',
            account: 'My account',
            bookings: 'My bookings',
            logout: 'Log out',
          },
        },
        DomainLanguageSwitcher: {
          countryAndLanguage: 'Wählen Sie Ihr Land und Ihre Sprache',
          europe: 'Europa',
          international: 'International',
        },
        FooterNewsletterSignup: {
          cta: 'Anmelden',
          title: 'Melden Sie sich zu unserem Newsletter an',
          text: 'Erhalten Sie regelmäßig Informationen über Neuigkeiten und besondere Angebote direkt in Ihren Posteingang.',
          emailPlaceholder: 'E-Mail',
        },
        BookmarkLink: {
          favorites: 'Merkliste',
        },
      },
      elements: {
        SearchBox: {
          pax_s: 'Gäste | 1 Gast | {count} Gäste',
          pet_s: 'Haustiere | 1 Haustier | {count} Haustiere',
          minpets: 'Haustiere | 1 Haustier | {count} Haustiere',
          where: 'Wo wollen Sie Ihren Urlaub verbringen?',
          when: 'Wann & wie lange?',
          with: 'Mit wem?',
          placeholders: {
            geo: 'Land, Region, Ort, Objektnummer',
            dates: 'Reisezeitraum',
            where: 'Wo wollen Sie Ihren Urlaub verbringen?',
            when: 'Wann & wie lange?',
            pax: 'Gäste inkl. Kinder',
            pets: 'Haustiere',
          },
          search: 'Suchen',
          country: 'Land',
          region: 'Region',
          place: 'Ort',
          accommodation: 'Ferienwohnung',
          quick: 'Unterkunft',
          yourSearch: 'Ihre Suche',
          C: 'Land',
          R: 'Region',
          P: 'Ort',
          H: 'Ferienhaus',
          A: 'Ferienwohnung',
          B: 'Boot',
          G: 'Gästezimmer',
        },
        SearchDates: {
          calendar: 'Kalender',
          flexible: 'Ich bin flexibel',
          apply: 'Anwenden',
          reset: 'Zurücksetzen',
        },
        Search: {
          placeholder: 'Land, Region, Ort, Objektnummer',
          search: 'Suchen',
          country: 'Land',
          region: 'Region',
          place: 'Ort',
          accommodation: 'Ferienwohnung',
          quick: 'Ferienwohnung',
          yourSearch: 'Ihre Suche',
        },
        Success: {
          success: 'Erfolg',
          transmission:
            'Herzlichen Dank, Ihre Daten wurden erfolgreich übermittelt.',
          continue: 'Sie können Ihre Suche hier fortsetzen.',
          inspiration: 'Weitere Urlaubsinspirationen',
        },
        Error: {
          errorText:
            'Leider ist ein Fehler aufgetreten. Versuchen Sie es bitte später nochmals.',
        },

        FlexibleDates: {
          custom: 'Andere',
          h_duration: 'Wie lange möchten Sie verreisen?',
          h_range: 'Wann verreisen Sie?',
          night_between: '{duration} von {start} - {end}',
          night_s: 'eine Nacht|{count} Nächte',
          week_s: 'eine Woche|{count} Wochen',
          tip_range:
            'Wählen Sie den Zeitraum aus, in dem Sie verreisen möchten',
        },
      },
      footer: {
        contact: {
          heading: 'Kontakt',
          support: 'Wir helfen Ihnen bei Fragen gerne persönlich weiter.',
          availability:
            'Montag - Freitag: 10:00 - 16:00 Uhr, Samstag: 15:00 - 20:00 Uhr, Sonntag: 10:00 - 14:00 Uhr',
        },
        newsletter: {
          heading: 'Newsletter',
          teaser: 'Ab sofort nichts mehr verpassen!',
          email: 'E-Mail-Adresse',
          submit: 'Newsletter abonnieren',
        },
        social: {
          heading: 'Folgen Sie uns',
        },
        about: {
          heading: {
            ih: 'Über Interhome',
          },
        },
        payment: {
          heading: 'Zahlungsarten',
          encrypted: 'Alle Daten werden verschlüsselt übertragen.',
          MAST: 'MasterCard',
          VISA: 'VISA',
          INV: 'Buchung auf Rechnung',
          PAYPAL: 'PayPal',
          ID: 'iDeal',
          ECV: 'chèque-vacances',
        },
        partner: {
          heading: 'Partnerschaften',
          brandingText: 'A HomeToGo Group brand',
          hometogo: 'HomeToGo',
          domains: 'Region und Sprache ändern',
        },
        copyright: '© HHD AG Schweiz {year}',
        cookieSettings: 'Cookie Einstellungen',
        siteFeedback: 'Feedback zur Website',
      },
      form: {
        FormField: {
          required: 'Bitte ausfüllen',
          invalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse an',
          unmatchedPattern: "Bitte verwenden Sie die Zeichen <>' nicht.",
        },
      },
      views: {
        Content: {
          Catalog: {
            order: 'Jetzt kostenfrei anfordern', // 24857"
            close: 'Schließen', // 39673"
            flip: 'Online blättern', // 38312"
            required: 'Bitte ausfüllen', // 18244"
            invalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse an', // 18232"
            gdpr: 'Wir verwenden Ihre eMail-Adresse, Anrede, Vor- und Nachnamen sowie Anschrift auf Grundlage von Art. 6 Abs. f, DSGVO zum Zweck der Zusendung des mit diesem Formular bestellten Kataloges oder Newsletters und zur Zusendung weiterer Informationen zu unserem Angebot. Weitere Informationen nach Art. 13 DSGVO finden Sie in unserer {dse} (nach § 13 TMG, Art. 13 DSGVO).', // 39675"
            privacyPolicy: 'Datenschutzerklärung', // 38826"
            form: {
              salutation: 'Anrede', // 16144"
              firstname: 'Vorname', // 16139"
              lastname: 'Nachname', // 16140"
              email: 'E-Mail', // 16136"
              mr: 'Herr', // 16146"
              ms: 'Frau', // 16147"
              street: 'Strasse & Hausnr.', // 16148"
              addressextra: 'Adresszusatz', // 16124"
              zip: 'Postleitzahl', // 16149"
              place: 'Ort', // 16143"
              country: 'Land', // 16132"
              phone: 'Telefonnummer', // 16141"
              newsletter: 'Newsletter', // 18210"
              adsFrom:
                'Ich möchte gezielt von Interhome zu bestimmten Urlaubsthemen beraten und informiert werden.', // 40375"
              submit: 'Absenden', // 16614"
            },
          },
          GeneralRequest: {
            yourRequest: 'Ihre Anfrage', // 38050"
            details: 'Persönliche Angaben', // 16151"
            gdpr: 'Wir verwenden Ihre in diesem Formular eingegebenen Daten auf Grundlage von Art. 6 Abs. b) DSGVO zum Zweck des Abschlusses und zur Abwicklung eines Vertrags und auf Grundlage von Art. 6 Abs.1 Buchst f) zur Zusendung weiterer Informationen zu unserem Angebot. Weitere Informationen nach Art. 13 DSGVO erhalten Sie in unserer {dse}.', // 39674"
            privacyPolicy: 'Datenschutzerklärung', // 38826"
            form: {
              salutation: 'Anrede', // 16144"
              firstname: 'Vorname', // 16139"
              lastname: 'Nachname', // 16140"
              email: 'E-Mail', // 16136"
              mr: 'Herr', // 16146"
              ms: 'Frau', // 16147"
              street: 'Strasse & Hausnr.', // 16148"
              addressextra: 'Adresszusatz', // 16124"
              zip: 'Postleitzahl', // 16149"
              place: 'Ort', // 16143"
              country: 'Land', // 16132"
              phone: 'Telefonnummer', // 16141"
              newsletter: 'Newsletter', // 18210"
              submit: 'Absenden', // 16614"
              request: 'Bitte teilen Sie uns besondere Wünsche mit', // 17193"
            },
          },
        },
        PageDetails: {
          headings: {
            description: 'Beschreibung', // 18156"
            map: 'Lage', // 18200"
            availability: 'Verfügbarkeit prüfen und buchen', // 16464"
            costoverview: 'Kostenübersicht', // 16480"
            reviews: 'Kundenbewertungen', // 16558"
            advantages: 'Weitere Vorteile', // 18097"
          },
          bookmarkAdd: 'Merken', // 16707"
          bookmarkDel: 'Gemerkt', // 16884"
          cookieSettings: 'Cookie Einstellungen', // 37986"
          invalidCode: 'Ungültiger Objektcode', // 40401"
          review_s:
            'Aktuell liegen uns noch keine Kundenbewertungen zu diesem Objekt vor | eine Bewertung | {count} Bewertungen', // 18442","34497","37506"
        },
        reviews: {
          Summary: {
            labels: {
              1: 'Mangelhaft', // 16371"
              2: 'Befriedigend', // 16372"
              3: 'Gut', // 18170"
              4: 'Sehr gut', // 16373"
              5: 'Ausgezeichnet', // 16369"
            },
            overallRating: 'Gesamtbewertung', // 16793"
            overallCondition: 'Gesamtzustand der Unterkunft', // 16919"
            overallCleanliness: 'Sauberkeit insgesamt', // 16895"
            overallService: 'Kundenservice vor Ort / Freundlichkeit', // 16915"
            basedOn_s:
              'Gesamtergebnis, basierend auf einer Kundenbewertung|Gesamtergebnis, basierend auf {count} Kundenbewertungen', // 39677", "39678"
          },
          Item: {
            condition: 'Gesamtzustand der Unterkunft', // 16919"
            cleanliness: 'Sauberkeit insgesamt', // 16895"
            service: 'Kundenservice vor Ort / Freundlichkeit', // 16915"
            reviewDate: 'Bewertet am {date}', // 37526"
            stay: 'Aufenthalt im {month}', // 16602"
            stayWith: 'Aufenthalt mit {with} im {month}', // 39679"
            response: 'Antwort von Interhome', // 37528"
            travelTips: 'Reisetipps', // 38123"
            extendedFamily: 'Erweitertem Familienkreis', // 16941"
            familyKids: 'Familie mit kleinen Kindern', // 16942"
            familyTeens: 'Familie mit Teenagern', // 16943"
            friends: 'Freunden', // 16944"
            group: 'Großer Gruppe', // 16945"
            partner: 'Ehepartner/Partner', // 16946"
            other: 'Andere', // 16939
            translate: 'Übersetzung anzeigen', // 39178"
            backToOriginal: 'Originaltext anzeigen', // 39179"
            byDeepl: 'Automatische Übersetzung von DeepL', // 39180"
          },
          Breadcrumb: {
            allReviews: 'Alle Kundenbewertungen', // 33584"
          },
          SearchTeaserTop: {
            chooseFromObjects:
              'Wählen Sie aus einem breiten Angebot von Ferienhäusern und Ferienwohnungen', // 39897"
            title: 'Kundenbewertungen', // 16558"
            cta: 'Zu den Unterkünften', // 28932"
            niceObjects: 'Die schönsten Ferienhäuser und Ferienwohnungen.', // 18355"
            objects: 'Ferienhäuser & Ferienwohnungen', // 16773"
          },
        },
        details: {
          Title: {
            labels: {
              toprated: 'Top-Rated', // 25199"
              new: 'Neu', // 16274"
            },
          },
          Features: {
            pax_s: 'keine Person | eine Person | {count} Personen', // 37530", "37531", "18073"
            room_s: 'keine Zimmer | ein Zimmer | {count} Zimmer', // 37532", "37537", "18071"
            bedroom_s: 'ein Schlafzimmer | {count} Schlafzimmer', // 37533", "37536", "18069",
            bathroom_s:
              'kein Bad | ein Bad | {count} Bäder | {count} slavic Bäder', // 37534", "37535", "38799", ??? slavic
          },
          Rating: {
            review_s:
              'Aktuell liegen uns noch keine Kundenbewertungen zu diesem Objekt vor | eine Kundenbewertung | {count} Kundenbewertungen', // 18442","34497","37506"
            labels: {
              1: 'Mangelhaft', // 16371"
              2: 'Befriedigend', // 16372"
              3: 'Gut', // 18170"
              4: 'Sehr gut', // 16373"
              5: 'Ausgezeichnet', // 16369"
            },
          },
          ModalGallery: {
            share: 'Teilen',
            facebook: 'Facebook',
            twitter: 'Twitter',
            email: 'E-Mail',
            whatsapp: 'WhatsApp',
            images: 'Galerie mit {n} Bildern',
            clickForFullsize:
              'Klicken Sie auf ein Bild, um es in voller Größe anzuzeigen.',
            next: 'Nächstes Bild',
            previous: 'Vorheriges Bild',
            loadError: 'Das Bild konnte nicht geladen werden.',
            bookmarkAdd: 'Merken', // 16707"
            bookmarkDel: 'Gemerkt', // 16884"
            open: 'Alle Bilder', // 38253"
            close: 'Schliessen', // 38254"
            inside: 'Innenbereich', // 18186"
            outside: 'Haus/Residenz', // 18182"
          },
          Gallery: {
            inside: 'Innenbereich', // 18186"
            outside: 'Haus/Residenz', // 18182"
          },
          Attributes: {
            views: {
              heading: 'Aussicht', // 39665" - Text/Formulierung noch nicht abgestimmt, engl. "Views"
              country_view: 'Landschaftsblick', // 18144"
              lake_view: 'Seeblick', // 18197"
              mountain_view: 'Bergsicht', // 18207"
              sea_view: 'Meersicht', // 18266"
            },
            distances: {
              heading: 'Distanzen', // 16572" - evt. besser "Entfernungen"?
              closeby: 'in direkter Nähe', // 18078"
              center: 'Nächster Ort / Ortsmitte {distance}', // 39666"
              public_transport: 'Öffentliche Verkehrsmittel {distance}', // 39667"
              bus: 'Proximity to bus station {distance}',
              train: 'Proximity to train station {distance}',
              ferry: 'Proximity to ferry station {distance}',
              tram: 'Proximity to tram station {distance}',
              metro: 'Proximity to metro station {distance}',
              beach: 'Strand {distance}', // 39668"
              sea: 'Meer {distance}', // 39669"
              lake: 'See {distance}', // 39670"
              golf: 'Golfplatz {distance}', // 39671"
              ski: 'Skipiste / Bergbahn {distance}', // 39672"
            },
            equipment: {
              heading: 'Ausstattung ', // 18163"
              aircondition: 'Klimaanlage', // 15827"
              balcony: 'Balkon / Terrasse', // 15828"
              bbq: 'Grill', // 15834"
              boat: 'Boot', // 28413"
              cots: 'Babybett', // 15843"
              dishwasher: 'Geschirrspüler', // 15848"
              fireplace: 'Kamin / Ofen', // 15880"
              fishing: 'Angelhaus', // 28464"
              certified_fishing: 'Zertifiziertes Angelhaus', // 28638"
              garage: 'Gemeinschaftsgarage', // 18137"
              hottub: 'Sprudelbad', // 15972"
              no_pets_allowed: 'Haustiere nicht erlaubt', // 37895"
              nonsmoking: 'Nichtraucher', // 15945"
              parking: 'Parkplatz', // 15905"
              patio: 'Balkon / Terrasse', // 15828"
              pets: 'Haustiere erlaubt', // 15931"
              pool: 'Pool', // 15932"
              pool_children: 'Kinderpool', // 15841"
              pool_indoor: 'Innenpool', // 15892"
              pool_private: 'Privater Pool', // 15936"
              sauna: 'Sauna', // 15942"
              single_garage: 'Einzelgarage', // 18275"
              suitable_for_wheelchairs: 'Rollstuhlgeeignet', // 18487"
              terrace: 'Balkon / Terrasse', // 15828"
              tv: 'TV', // 15967"
              washingmachine: 'Waschmaschine', // 15969"
              wlan: 'WiFi', // 15896",
              workation: 'Workation', // 39991",
            },
            sustainability: {
              heading: 'Nachhaltigkeit', // 41662"
              charging_station: 'E-Ladestation', // 41666"
              double_glazed_windows: 'Doppelt verglaste Fenster', // 41670"
              ecological_heating_system: '100% ökologisches Heizsystem', // 41664"
              green_space_garden: 'Garten', // 41671"
              led_bulbs: 'LED-Lampen', // 41668"
              recycling_station: 'Recycling', // 41667"
              renewable_electricity: '100% erneuerbarer Strom', // 41663"
              solar_panels: 'Sonnenkollektoren / Photovoltaik-Anlage', // 41665"
              water_efficient_showers: 'Wassersparende Toiletten / Duschen', // 41669"
            },
          },
          Description: {
            from: 'von', // 27798"
            fromto: 'ab', // 27873"
            to: 'bis', // 27799"
            // moreDetails: 'Weitere Informationen', // 38838" - unklar, ob das verwendet wird - ist aber in CF-Detailpage.cfc für AccommodationModalDescription.vue angelegt
            headings: {
              inside: 'Innenbereich', // 18186"
              outside: 'Außenbereich', // 18182"
              destination: 'Ortsbeschreibung', // 16653"
              general: 'Generell', // 15987"
              summer: 'Sommer', // 15988"
              winter: 'Winter', // 15989"
            },
            trustMessage:
              'Die genaue Adresse zu Ihrem Feriendomizil erhalten Sie rechtzeitig vor Ihrer Reise mit den Reiseunterlagen.', // 27756"
          },
          Residence: {
            showAllAccommodations:
              'Alle {count} Wohnungen in diesem Haus/dieser Residenz anzeigen', // 39680"
          },
          Map: {
            accuracyHint:
              'Es wird das Zentrum des Ortes angezeigt, nicht die Lage des Ferienhauses.', // 18358"
            activation:
              'Lassen Sie sich hier die Lage der Unterkunft anzeigen.', // 28091"
            activate: 'Kartenansicht aktivieren', // 28092"
          },
          Services: {
            chooseTravelPeriod: 'Bitte wählen Sie zuerst Anreise - Abreise', // 33423"
            included: 'Im Preis enthaltene Leistungen', // 18426"
            // excluded: 'Nicht im Preis enthalten (obligatorisch)', // 16586" - ??? unklar, ob das noch verwendet wird
            extracostsOnPlace:
              'Obligatorische Nebenkosten, zu zahlen an den lokalen Dienstleister, nach tatsächlicher Belegung bzw. tatsächlichem Verbrauch', // 18220"
            optionalServices: 'Optionale Zusatzleistungen', // 18425"
            selfOrganised: 'Selbst zu organisieren', // 18447"
            co2Information: 'Mehr Informationen zur CO2 Kompensation', // 39410"
            inszInformation: 'Mehr Informationen zur Reiseversicherung', // 18098"
            inszRecommendation:
              'Wir empfehlen Ihnen den Abschluss des ERV Reiseschutzes.', // 18373"
            susuInformation: 'Mehr Information', // 39529"
            loading: 'Daten werden geladen', // 39681"
            to: 'bis', // 38980"
            from: 'von', // 38981"
          },
          Sidebar: {
            messages: {
              EX: 'Bitte wählen Sie Ihren Reisetermin aus.', // 25130"
              LOADING: 'Daten werden geladen', // 39681"
              NA: 'Ihr Termin ist nicht verfügbar', // 18216"
              OK: 'Ihr Termin ist verfügbar.', // 18147"
              RQ: 'Auf Anfrage', // 16382"
              RP: 'Auf Anfrage',
            },
            placeholder: 'Bitte auswählen', // 18246"
            labels: {
              checkin: 'Anreise', // 16465"
              checkout: 'Abreise', // 24926"
              pax: 'Erwachsene und Kinder', // 39531"
            },
            price: {
              base: 'Preis pro Person und Nacht', // 38786"
              total: 'Gesamt für {duration} Nächte', // 38787"
            },
            saved: 'gespart', // 18265"
            priceFrom: 'ab', // 16618" - ACHTUNG: ih_cms_from / search ("ab"), nicht durcheinanderbringen mit 27798 ih_cms_from / detailpage ("von")
            eg: 'z.B.', // 25180"
            additionalCosts: 'Nebenkosten', // 18448"
            toOverview: 'Zur Übersicht', // 38788"
            paxNoDuration: 'Bitte wählen Sie Ihren Reisetermin aus.', // 25130"
            paxAfterDuration: 'Danach können Sie die Zahl der Reisenden ändern', // 25130"
            priceOccupancy:
              'Der angezeigte Preis ist von der Belegung abhängig', // 38789"
            person_s: 'eine Person|{count} Personen', // 37530", "37531", "18073" - "38701" mit Pluralization in der Textresource, besser neu zusammensetzen wie pax_s: 'keine Person | eine Person | {count} Personen'
            button: {
              labels: {
                EX: 'Verfügbarkeit prüfen', // 16463"
                LOADING: 'Daten werden geladen', // 39681"
                OK: 'Zur Buchung', // 18125"
                RQ: 'Auf Anfrage', // 16382"
                RP: 'Auf Anfrage',
                NA: 'Nicht verfügbar', // 16758"
                OP: 'Option erstellen', // 16392"
              },
            },
            summary:
              'Vor der Buchung erhalten Sie eine übersichtliche Zusammenfassung', // 18058"
          },
          MobileBar: {
            priceFrom: 'ab', // 16618" // ACHTUNG: ih_cms_from / search ("ab"), nicht durcheinanderbringen mit 27798 ih_cms_from / detailpage ("von")
            eg: 'z.B.', // 25180"
            person_s: 'eine Person|{count} Personen', // 37530", "37531", "18073" - "38701" mit Pluralization in der Textresource, besser neu zusammensetzen wie pax_s: 'keine Person | eine Person | {count} Personen'
            upToPax: 'bei Belegung bis {count} Pers.', // 37408"
            changeDate: 'Reisedaten ändern', // 39723"
            additionalCosts: 'zuzüglich ggf. Nebenkosten', // 18334"
            button: {
              labels: {
                EX: 'Verfügbarkeit prüfen', // 16463"
                LOADING: 'Daten werden geladen', // 39681"
                OK: 'Zur Buchung', // 18125"
                RQ: 'Auf Anfrage', // 16382"
                RP: 'Auf Anfrage',
                NA: 'Nicht verfügbar', // 16758"
                OP: 'Option erstellen', // 16392"
              },
            },
            tooltip: {
              addCosts: 'zuzüglich ggf. Nebenkosten',
              addCostsLong:
                'zuzüglich obligatorischer oder fakultativer Nebenkosten nach tatsächlicher Belegung beziehungsweise tatsächlichem Verbrauch',
              dependentPrice: 'Preis abhängig von Zeitraum und Personenzahl',
              priceAfterInput:
                'Ihr Mietpreis wird nach Eingabe der Anzahl Reisender sowie Ihres Reisezeitraumes angezeigt.',
            },
          },
          SocialShare: {
            button: 'Teilen', // 18269"
            whatsApp:
              'Hier ist eine tolle Unterkunft auf Interhome! Wie gefällt sie Dir?', // 41661"
          },
          SidebarContactCard: {
            furtherQuestions: 'Haben Sie weitere Fragen?', // 18160"
            '24_7': 'Wir sind 24 Stunden für Sie erreichbar!', // 18372"
            contactUs: 'Kontaktieren Sie uns', // 16607"
            counsel:
              'Sie erreichen uns hier rund um die Uhr - zur Buchungsberatung, vor Ihrer Anreise oder wenn Sie direkt vor Ort sind, stehen wir Ihnen jederzeit mit Rat und Tat zur Seite.', // 18143"
            generalRequest: 'Anfrageformular', // 16476"
            order: 'Urlaubsangebot bestellen', // 16477"
          },
          TrustPilot: {
            userRating: 'Unsere Kunden bewerten uns wie folgt', // 38454"
          },
          Vacancy: {
            legend: {
              title: 'Legende', // 39682"
              arrival: 'Mögliches Anreisedatum', // 18247"
              departure: 'Mögliches Abreisedatum', // 24946"
              discount: 'Profitieren Sie: Anreisedatum mit Spezialpreis', // 24951"
              noarrival: 'Verfügbar, jedoch kein Anreisedatum', // 24942"
              nodeparture: 'Verfügbar, jedoch kein Abreisedatum', // 24943"
              disabled: 'Nicht verfügbar', // 16758"
              yourSelection: 'Ihre Auswahl: Anreise & Abreisedatum', // 24948"
              available: 'Verfügbar, jedoch kein Anreisedatum', // 24942"
              na: 'Nicht buchbar', // 39683"
            },

            headline: {
              arrival: 'Anreisedatum wählen', // 24940"
              departure: 'Abreisedatum wählen', // 24941"
            },
            night_s: 'eine Nacht|{count} Nächte', // 37500", "37501"
          },
          Calendar: {
            arrivalDeparture_s:
              'Anreise- und Abreisedatum (min. eine Nacht)|Anreise- und Abreisedatum (min. {count} Nächte)', // 39686", "39687"
            arrival_s:
              'Mögliches Anreisedatum (min. eine Nacht)|Mögliches Anreisedatum (min. {count} Nächte)', // 39690", "39691"
            noArrival: 'Verfügbar, jedoch kein Anreisedatum', // 24942"
            departureOnly: 'Nur Abreise', // 18153"
            notAvailable: 'Nicht verfügbar', // 16758"
            selectedArrival_s:
              'Ihr gewählter Anreisetag mit einer minimalen Aufenthaltsdauer von einer Nacht|Ihr gewählter Anreisetag mit einer minimalen Aufenthaltsdauer von {count} Nächten', // 39692", "37525"
            dateInPast: 'Gewählter Tag liegt in der Vergangenheit', // 39693"
            arrivalBeforeDeparture: 'Anreisetag muss vor Abreisetag liegen', // 39694"
            noDepartureMinStay_s:
              'Keine Abreise möglich, Mindestaufenthalt eine Nacht|Keine Abreise möglich, Mindestaufenthalt {count} Nächte', // 39695", "39696"
            noDepartureMaxStay_s:
              'Keine Abreise möglich, maximale Aufenthaltsdauer eine Nacht|Keine Abreise möglich, maximale Aufenthaltsdauer {count} Nächte', // 39698","39697"
            noDeparture: 'Keine Abreise möglich', // 24933"
            departureAvailable: 'Abreise möglich', // 24931"
          },
          CancelConditions: {
            heading: 'Stornobedingungen', // '18129'
            until: 'Bis', // '17005'
            daysBefore: 'Tage vor Mietbeginn', // '18152'
            ofRental: 'des Mietpreises', // '18222'
            full: 'Tag vor Mietbeginn und am Anreisetag ist der gesamte Rechnungsbetrag geschuldet.', // '18151'
            moreThan: 'Bis zu', // '38908'
            close: 'Schließen',
            from: 'ab',
            noRefund: 'keine Rückerstattung',
            refund: 'Rückerstattung',
            viewCancellationConditions: 'Stornierungsbedingungen anzeigen',
          },
          Reviews: {
            review_s:
              'Aktuell liegen uns noch keine Kundenbewertungen zu diesem Objekt vor | eine Bewertung | {count} Bewertungen', // 18442","34497","37506"
            filters: 'Bewertungen von', // 39917"
            all: 'allen Gruppen', // 39699"
            choose: 'Bitte wählen', // 16940"
            extendedFamily: 'Erweitertem Familienkreis', // 16941"
            familyKids: 'Familie mit kleinen Kindern', // 16942"
            familyTeens: 'Familie mit Teenagern', // 16943"
            friends: 'Freunden', // 16944"
            group: 'Großer Gruppe', // 16945"
            partner: 'Ehepartner/Partner', // 16946"
            other: 'Andere', // 16939
            loading: 'Daten werden geladen', // 39681"
          },
          Breadcrumbs: {
            home: 'Home', // 16732"
          },
          MonthlyPrices: {
            tooltip:
              'Die Grafik zeigt den durchschnittlichen Mietpreis für jeden Monat als Index. Kleinere Balken bedeuten niedrigere Preise.',
            title: 'Preisindex',
            info: 'Preise abhängig von Zeitraum und Personenzahl',
          },
          UserSurvey: {
            title: 'Was ist Ihnen besonders wichtig?', // 42820
            text: 'Gerne würden wir mehr über Ihre Bedürfnisse erfahren. Worauf legen Sie beim Urlaub im Ferienhaus besonderen Wert? Teilen Sie uns Ihre Vorlieben in einer kurzen Umfrage mit (Dauer: ca. 5 Minuten)', // 42821
            buttons: {
              open: 'Jetzt teilnehmen', // 42822
              postpone: 'Vielleicht später', // 42824
            },
          },
          LinkedObjects: {
            title: 'Find more holiday homes',
          },
          CO2Footprint: {
            title: '{total} kg CO₂e for {duration} nights',
            description:
              'The carbon footprint of this accommodation is {perNight} kg per night at full occupancy.',
            tooltip:
              "<p>We are actively committed to sustainability and consider transparency to be important. Together with the Austrian company BEESark, we have calculated the exact CO₂e footprint for this accommodation.</p><p>The emissions were calculated using the maximum occupancy per night. These values are an essential part of our climate target: we want to halve Interhome's CO₂e footprint by 2030.</p>",
          },
        },
        newsletter: {
          Success: {
            // ??? Grundsatzfragen noch zu besprechen, weil an anderen Stellen auch noch verwendet
            success: 'Erfolg', // 39661"
            transmission:
              'Die Daten wurden erfolgreich übermittelt. Vielen Dank!', // 16606"
            continue: 'Sie können Ihre Suche hier fortführen.', // 39662"
            inspiration: 'Suchen Sie nach Inspiration?', // 25087"
          },
          Error: {
            errorText:
              'Leider ist ein Fehler aufgetreten. Versuchen Sie es bitte später nochmals.', // 16605"
          },
        },
        favorites: {
          Actions: {
            catalog: {
              privacyPolicy: 'Datenschutzerklärung', // 38826"
              create: 'Erstellen Sie Ihren persönlichen Katalog (PDF)', // 16556"
              title: 'Persönlicher Katalog', // 17053"
              fillForm:
                'Füllen Sie folgendes Formular aus. Ihr persönlicher Katalog wird Ihnen dann innerhalb weniger Minuten als PDF per eMail zugestellt.', // 17263"
              emailError: 'Bitte geben Sie eine gültige E-Mailadresse an.', // 18232"
              salutation: 'Anrede', // 16144"
              firstname: 'Vorname', // 16139"
              lastname: 'Nachname', // 16140"
              email: 'E-Mail', // 16136"
              mr: 'Herr', // 16146"
              ms: 'Frau', // 16147"
              pax: 'Gäste inkl. Kinder', // 18172"
              dates: 'Reisezeitraum', // 18292"
              newsletter: 'Melden Sie sich zu unserem Newsletter an', // 41154"
              gdprNewsletter:
                'Wir verwenden Ihre eMail Adresse, Anrede sowie Vor- und Nachnamen auf Grundlage von Art. 6 Abs. f, DSGVO zum Zweck der Zusendung des mit diesem Formular bestellten Newsletters und zur Zusendung weiterer Informationen zu unserem Angebot. Weitere Informationen nach Art. 13 DSGVO finden Sie in unserer {dse}.', // 39676"
              gdprRegular:
                'Wir verwenden Ihre in diesem Formular eingegebenen Daten auf Grundlage von Art. 6 Abs. b) DSGVO zum Zweck des Abschlusses und zur Abwicklung eines Vertrags und auf Grundlage von Art. 6 Abs.1 Buchst f) zur Zusendung weiterer Informationen zu unserem Angebot. Weitere Informationen nach Art. 13 DSGVO erhalten Sie in unserer {dse}.', // 39674"

              send: 'Absenden', // 16614"
            },
            removeAll: 'Alle Objekte von der Merkliste entfernen', // 17260"
          },
          Breadcrumbs: {
            home: 'Home', // 16732"
            favorites: 'Merkliste', // 18208"
          },
          Error: {
            text: 'Leider ist ein Fehler aufgetreten. Versuchen Sie es bitte später nochmals.', // 16605"
          },
          Filters: {
            country: 'Land', // 16481"
            region: 'Region', // 16881"
            place: 'Ort', // 16815"
            pax: 'Reisende', // 39218"
            all: 'Alle', // 39700"
            any: 'beliebig', // 16356"
          },
          Infobox: {
            heading:
              'Ihre Merkliste enthält Unterkünfte mit belegungsabhängigen Preisen.', // 35764"
            info: 'Die hier dargestellten Preise beziehen sich auf eine Belegung mit einer Person und können bei anderer Belegung abweichen.', // 39702"
            ok: 'OK', // 39703"
          },
          Success: {
            text: 'Herzlichen Dank, Ihre Daten wurden erfolgreich übermittelt.', // 16606"
          },
        },
        search: {
          newFilter: {
            filterTitle: {
              results: 'Ein Ergebnis|{count} Ergebnisse',
              for: 'für',
              sort: 'Sortierung:',
              recommendation: 'Unsere Empfehlung',
            },
            filterSection: {
              rooms: 'Räume',
              facilities: 'Ausstattung',
              price: 'Preis',
              houseType: 'Haustyp',
              distances: 'Distanzen',
              activities: 'Aktivitäten',
              features: 'Features',
              offers: 'Angebote',
              starRating: 'Sternebewertung',
              propertyType: 'Eigenschaftstype',
              accommodationType: 'Unterkunftstyp',
              holidayType: 'Urlaubsart',
            },
            filterSections: {
              price: {
                priceMin: 'Min',
                priceMax: 'Max',
                last_minute: 'Last Minute',
                special_offer: 'Alle Sonderangebote',
                early_booker: 'Frühbucher Rabatt',
                'discount-20': '≥20% Rabatt',
              },
            },
          },
          filter: {
            country: 'Land', // 16481"
            region: 'Region', // 16881"
            place: 'Ort', // 16815"
            checkin: 'Anreise', // 24947"
            checkout: 'Abreise', // 24926"
            trip: 'Reisezeitraum', // 18292"

            pax: 'Erwachsene und Kinder', // 39531"
            bedrooms: 'Schlafzimmer', // 16379"
            bathrooms: 'Badezimmer', // 17373"

            house: 'Ferienhaus', // 15984"
            apartment: 'Ferienwohnung', // 15980"
            villa: 'Villa', // 15986"
            chalet: 'Chalet', // 15981"
            farmhouse: 'Landhaus', // 15983"
            // residence: 'Sterne',
            studio: 'Studio', // 15835"
            detached: 'Alleinstehendes Haus', // 15847"

            casa: 'CASA entdecken', // 28908"
            swiss_peak: 'SWISSPEAK Resorts', // 28909"
            workation: 'Workation', // 39991",
            sustainable: 'Nachhaltige Unterkünfte', // 41647"

            stars: 'Sterne-Klassifizierung', // 15961"

            pool: 'Pool', // 15932"
            pool_children: 'Kinderpool', // 15841"
            pool_indoor: 'Innenpool', // 15892"
            pool_private: 'Privater Pool', // 15936"

            pets: 'Haustiere erlaubt', // 18229"
            minpets: 'Haustiere | 1 Haustier | {count} Haustiere',

            maxPrice: 'Maximum price',
            'min-price': 'Minimum price',

            sea: 'Nähe zum Meer', // 15875"
            lake: 'Nähe zum See', // 15874"
            ski: 'Nähe zu Skipiste / Bergbahn', // 15876"
            center: 'Nächster Ort / Ortsmitte', // 15872"

            wlan: 'WLAN', // 15896"
            aircondition: 'Klimaanlage', // 15827"
            parking: 'Parkplatz', // 15905"
            garage: 'Garage', // 28461"
            'balcony-or-terrace': 'Balkon / Terrasse', // 15828"
            dishwasher: 'Spülmaschine', // 15848"
            washingmachine: 'Waschmaschine', // 15969"
            tv: 'Fernseher', // 15967"
            sea_or_lake_view: 'Seeblick', // 15943"
            bbq: 'Grill', // 15834"
            boat: 'Boot', // 28413"
            cots: 'Babybett', // 15843"
            hottub: 'Sprudelbad', // 15972"
            fireplace: 'Kamin / Ofen', // 15880"
            sauna: 'Sauna', // 15942"
            wheelchair: 'Rollstuhlgeeignet', // 15971"
            charging_station: 'E-Ladestation', // 41666"

            last_minute: 'Last Minute', // 15952"
            special_offer: 'Alle Sonderangebote', // 15948"
            'discount-20': '≥ 20% Rabatt', // 15950"
            cheapcheap: 'Gut und günstig', // 15949"
            early_booker: 'Frühbucher Rabatt', // 15951"

            familyfriendly: 'Familienfreundlich', // 8515"
            holiday_resort: 'Ferienanlage', // 8526"
            residence: 'Residenzen', // 8574"
            citytrips: 'Städtereise', // 15842"

            fishing: 'Angelhaus', // 28464"
            fishing_certified: 'Zertifziertes Angelhaus', // 28638"

            skiing: 'Skifahren / Snowboard', // 15944"
            hiking: 'Wandern', // 15888"
            golfing: 'Golf', // 15886"
            cycling: 'Radfahren', // 15846"
            wellness: 'Wellness', // 15970"
            tennis: 'Tennis', // 15964"
            surfing: 'Surfen', // 15962"
            sailing: 'Segeln', // 15941"
            mountainbiking: 'Mountainbiken', // 15900"
            riding: 'Reiten', // 15940"
            crosscountryskiing: 'Langlaufen', // 15845"

            q: 'Ihre Suche', // 39538"

            // Freeweek
            freeweekCategoryA: 'Category A',
            freeweekCategoryB: 'Category B',
            freeweekCategoryC: 'Category C',

            labels: {
              refine: 'Suche verfeinern', // 18258"
              where: 'Wohin möchten Sie?', // 18377"
              when: 'Wann möchten Sie verreisen?', // 18376"
              pax: 'Wie viele Personen verreisen?', // 39918"

              accomtype: 'Ferienhaustyp', // 18369"
              particular: 'Suchen Sie das besondere?', // 28910"

              pool: 'Swimming-Pool', // 15933"
              pet: 'Möchten Sie Ihr Haustier mitnehmen?', // 18382"
              distances: 'Distanzen', // 16572"

              facilities: 'Ausstattung', // 15965"
              specials: 'Angebote', // 15954"
              maxPrice: 'Max. Preis pro Aufenthalt', // 15978"
              fishing: 'Planen Sie einen Angelurlaub?', // 28514"
              holidaytype: 'Urlaubsart', // 15889"
              activities: 'Aktivitäten vor Ort', // 39894"
              atleast: 'mind. {value}', // 39895"

              // Freeweek
              freeweekCategory: 'Freeweek category',
            },

            selected: 'Selected',
            noResults: {
              title: 'No exact matches found',
              description: 'Search help',
              hintDates: 'Try on flexible dates',
              hintLocations: 'Check locations nearby',
              hintFilters: 'Remove some filters from your list',
            },
          },
          InfoWindowLegacy: {
            pax_s: 'keine Person | eine Person | {count} Personen', // 37530", "37531", "18073"
            room_s: '{count} Raum | {count} Räume', // 37532", "37537", "18071"
            night_s: 'eine Nacht|{count} Nächte', // 37500", "37501"
            discover: 'Entdecken', // 18157"
            objects: '{count} Angebote', // 39916"
            priceFrom: 'ab', // 16618"
          },
          RatingBox: {
            title: 'Kundenbewertungen', // 16558"
            labels: {
              1: 'Mangelhaft', // 16371"
              2: 'Befriedigend', // 16372"
              3: 'Gut', // 18170"
              4: 'Sehr gut', // 16373"
              5: 'Ausgezeichnet', // 16369"
            },
            ratingText:
              'Kunden haben diese Unterkünfte mit {ratingaverage} von maximal 5 Punkten bewertet.', // 24893"
            numberRatingsText: 'Basiert auf {ratingcount} Bewertungen.', // 24897"
          },
          area: {
            heading: 'Suche', // 16972" ??? Suchen
            noResults: 'Leider konnten wir kein passendes Suchresultat finden.', // 18427"
            noResultsRecommender: {
              sameRegion:
                'We have extended the search to the region with your selected filters',
              extendedDates:
                'We have extended the search to the flexible dates ± 3 nights with your selected filters',
            },
            modifyFilters:
              'Bitte versuchen Sie es erneut, indem Sie Ihre Suchkriterien anpassen bzw. entfernen.', // 18428"
            addFilters: 'Filter hinzufügen', // 39896"
            filters: 'Filter',
            removeAllFilters: 'Alle Filter entfernen', // 18260
            map: 'Karte', // 16665" - auch "18201"
            list: 'Liste', // 16648"
            sorting: {
              age: 'Newest first',
              bestsellers: 'Best Sellers',
              heading: 'Sorting',
              paxAsc: 'Number of persons (ascending)',
              paxDesc: 'Number of persons (descending)',
              prefix: 'Sort by:',
              priceAsc: 'Price (ascending)',
              priceDesc: 'Price (descending)',
              rating: 'Customer Reviews',
              recommendation: 'Our recommendations',
            },
            layout: {
              grid: 'Grid',
              list: 'List',
            },
            wishlistModal: {
              title: 'Add to wishlist',
              createNewTitle: 'Create new wishlist',
              propsCounter: '{counter} properties',
              create: 'Create new wishlist',
              addSuccess: 'Saved to {wishlistName}',
              removeSuccess: 'Removed from {wishlistName}',
              cancel: 'Cancel',
              continue: 'Continue',
              label: 'Wishlist name',
              error: 'Something went wrong',
              change: 'Change',
            },
            wishlist: {
              propsCounter: '{counter} properties',
            },
          },
          Breadcrumbs: {
            home: 'Home', // 16732"
          },
          searchTeaser: {
            headingDestination:
              '{geoname} - Ferienhaus & Ferienwohnung mieten für Ihren Urlaub:', // 20278",
            headingDestinationNoPlaceholder:
              'Ferienhaus & Ferienwohnung mieten für Ihren Urlaub:', // 42062",
            headingFilter: '{destandfilter} - Ferienhaus und Ferienwohnung in:', // 39930"
            headingFilterNoPlaceholder: 'Ferienhaus und Ferienwohnung in:', // 42061"
          },
          NewsletterSignup: {
            cta: 'Anmelden',
            text: 'Melden Sie sich zu unserem Newsletter an',
          },
          ObjectTeaser: {
            withDestination: {
              destination: {
                reviews: {
                  title:
                    'Top-rated holiday houses in {destination} for unforgettable getaways',
                  description:
                    'Experience the best-rated holiday houses in {destination} for an unforgettable holidays, blending superior quality, top service, and outstanding reviews.',
                },
                sustainable: {
                  title:
                    'Sustainable holiday homes in {destination} for nature-friendly retreats',
                  description:
                    'Embrace sustainable living in our eco-friendly vacation rentals in {destination}, combining green practices and environmental harmony for perfect vacation',
                },
                wlan: {
                  title:
                    'Vacation rentals in {destination} with high-speed WiFi connectivity',
                  description:
                    'Stay connected in our holiday homes in {destination} boasting high-speed WiFi connectivity during your stay.',
                },
                parking: {
                  title:
                    'Holiday homes with convenient parking access in {destination}',
                  description:
                    'Holiday homes with convenient parking access in {destination}',
                },
                aircondition: {
                  title:
                    'Cool comfort: accommodations with refreshing air-conditioning in {destination}',
                  description:
                    'Enjoy cool comfort in our holiday houses in {destination} equipped with refreshing air conditioning for ultimate relaxation.',
                },
              },
              pool: {
                reviews: {
                  title:
                    'Pool paradise: top-rated holiday accommodations with pool in {destination}',
                  description:
                    'Discover top-rated holiday houses with pool in {destination} - your perfect retreat for unforgettable, leisure-filled vacations!',
                },
                sustainable: {
                  title:
                    'Discover eco-friendly accommodations with pool in {destination} for perfect holiday',
                  description:
                    'Indulge in our sustainable vacation rentals with pools in {destination} for an unforgettable, eco-conscious escape.',
                },
                wlan: {
                  title: 'Vacation rentals with pool and WiFi in {destination}',
                  description:
                    'Stay connected and refreshed in our vacation homes in {destination}, offering poolside relaxation and high-speed WiFi for your convenience!',
                },
                parking: {
                  title:
                    'Holiday homes with pool and convenient parking in {destination}',
                  description:
                    'Unwind in our holiday houses with swimming pools in {destination}, each providing your own parking space for ultimate convenience.',
                },
                aircondition: {
                  title:
                    'Refreshing comfort: apartments & cottages with pool & air-conditioning in {destination}',
                  description:
                    'Discover comfort and coolness in our apartments in {destination}, featuring refreshing pools and air-conditioning for your ultimate holiday!',
                },
              },
              sea: {
                reviews: {
                  title:
                    'Seaside relaxation: top-rated accommodations by the sea in {destination}',
                  description:
                    'Immerse yourself in the serene beauty of our top-rated holiday accommodations by the sea in {destination} for an unforgettable retreat!',
                },
                sustainable: {
                  title:
                    'Eco-sea holidays: sustainable homes near a coastline in {destination}',
                  description:
                    'Embrace eco-friendly living in our sustainable accommodations in {destination} close to the sea, blending comfort with care for nature!',
                },
                wlan: {
                  title:
                    'Vacation rentals by the sea with WiFi in {destination}',
                  description:
                    'Stay connected in our seaside holiday homes in {destination}, offering high-speed WiFi to enhance your relaxing escape!',
                },
                parking: {
                  title:
                    'Holiday homes by the sea with parking in {destination}',
                  description:
                    'Relish in our seaside holiday rentals in {destination}, providing you with unparalleled views and your own parking convenience.',
                },
                aircondition: {
                  title:
                    'House rentals by the sea with air-conditioning in {destination}',
                  description:
                    'Experience refreshing sea breezes and cool comfort in our holiday apartments by the sea in {destination} with air-conditioning.',
                },
              },
              pets: {
                reviews: {
                  title:
                    'Pet paradise: top-rated holiday homes for furry friends in {destination}',
                  description:
                    'Your pet-friendly paradise awaits in our top-rated holiday accommodations in {destination}, perfectly tailored for your furry friends.',
                },
                sustainable: {
                  title:
                    'Green getaways: sustainable, pet-welcome holiday homes await in {destination}',
                  description:
                    'Share eco-friendly comfort with your pet in our sustainable holiday houses in {destination}, where nature and nurture coexist.',
                },
                wlan: {
                  title:
                    'Perfect pet-friendly homes with WiFi in {destination}',
                  description:
                    'Stay connected in our perfect pet-welcoming holiday homes in {destination}, blending comforts with high-speed WiFi for you.',
                },
                parking: {
                  title:
                    'Pet-Friendly accommodations with convenient parking in {destination}',
                  description:
                    'Delight in our pet-friendly apartments & cottages in {destination}, offering ample parking for a seamless and comfortable stay.',
                },
                hiking: {
                  title:
                    'Dog-friendly apartments & houses for hiking adventures in {destination}',
                  description:
                    'Discover our pet-friendly holiday accommodations in {destination}, ideally located for unforgettable dog-friendly hiking adventures.',
                },
              },
              skiing: {
                reviews: {
                  title:
                    'Top-rated accommodations for skiing holidays in {destination}',
                  description:
                    'Embrace the winter fun with our top-rated holiday accommodations in {destination}, perfectly situated for your unforgettable skiing holidays.',
                },
                sustainable: {
                  title:
                    'Eco-friendly retreats: sustainable homes for skiing holidays in {destination}',
                  description:
                    'Choose our sustainable holiday homes in {destination} for your skiing adventures, where eco-friendly living meets mountain thrill!',
                },
                wlan: {
                  title:
                    'Stay connected: perfect skiing holiday homes with WiFi in {destination}',
                  description:
                    'Stay connected on the slopes in our perfect vacation rentals for skiing in {destination}, featuring high-speed WiFi for your convenience.',
                },
                fireplace: {
                  title:
                    'Winter comfort: apartments & chalets with cozy fireplaces in {destination}',
                  description:
                    'Warm up in our apartments & chalets at the ski area in {destination}, offering cozy fireplaces for your perfect winter retreat.',
                },
                cheapcheap: {
                  title:
                    'Affordable skiing retreats: cheap holiday apartments and houses in {destination}',
                  description:
                    'Experience affordable comfort in our cheap holiday apartments and houses in {destination}, ideally located for your exciting skiing adventures.',
                },
              },
              familyfriendly: {
                reviews: {
                  title:
                    'Top-bewertete familienfreundliche Unterkünfte in {destination}',
                  description:
                    'Freuen Sie sich auf einen unvergesslichen Familienurlaub und wählen Sie eine der top-bewerteten, familienfreundlichen Unterkünfte in {destination} für Ihre nächste Auszeit aus.',
                },
                sustainable: {
                  title:
                    'Zeit für eine umweltbewusste Auszeit: nachhaltige und familienfreundliche Ferienhäuser in {destination}',
                  description:
                    'Entdecken Sie umweltfreundliche und familienfreundliche Ferienhäuser in {destination}, die Nachhaltigkeit mit Entspannung verbinden und Ihrer Familie damit eine umweltbewusstere Möglichkeit bieten, den Urlaub zu genießen.',
                },
                wlan: {
                  title:
                    'Bleiben Sie in Verbindung: perfekte Unterkünfte für Ihren Familienurlaub in {destination} mit WiFi',
                  description:
                    'Genießen Sie Ihren Urlaub in familienfreundlichen Unterkünften in {destination}. Ausgestattet mit WiFi bleiben Kinder und Erwachsene hier in Verbindung',
                },
                parking: {
                  title:
                    'Entdecken Sie familienfreundliche Ferienhäuser mit bequemen Parkmöglichkeiten in {destination}',
                  description:
                    'Starten Sie entspannt in den Urlaub mit diesen einladenden Familienunterkünften in {destination}. Sie bieten bequeme Parkmöglichkeiten und sorgen somit für einen stressfreien und angenehmen Aufenthalt.',
                },
                aircondition: {
                  title:
                    'Erfrischender Komfort: Familienfreundliche Ferienwohnungen & Ferienhäuser mit Klimaanlage in {destination}',
                  description:
                    'Mit unseren familienfreundlichen Ferienwohnungen mit Klimaanlage in {destination} bewahren Sie einen kühlen Kopf und können Ihren Urlaub rundum genießen.',
                },
              },
            },
            withoutDestination: {
              pool: {
                reviews: {
                  title:
                    'Pool-Paradies: Top-bewertete Ferienunterkünfte mit Pool',
                  description:
                    'Entdecken Sie die besten Ferienhäuser mit Pool  - Ihr perfekter Rückzugsort für einen unvergesslichen, erlebnisreichen Urlaub!',
                },
                sustainable: {
                  title:
                    'Entdecken Sie umweltfreundliche Unterkünfte mit Pool für einen perfekten Urlaub',
                  description:
                    'Gönnen Sie sich in unseren nachhaltigen Ferienunterkünften mit Pool einen unvergesslichen, umweltbewussten Urlaub.',
                },
                wlan: {
                  title: 'Ferienunterkünfte mit Pool und WiFi',
                  description:
                    'Bleiben Sie mit kühlem Kopf in Verbindung in unseren Ferienhäusern: Sie bieten Ihnen Entspannung am Pool und High-Speed-WiFi für Ihren Komfort!',
                },
                parking: {
                  title: 'Ferienhäuser mit Pool und bequemer Parkmöglichkeit',
                  description:
                    'Entspannen Sie sich in unseren Ferienhäusern mit Pool, von denen jedes für den höchsten Komfort über einen eigenen Parkplatz verfügt.',
                },
                aircondition: {
                  title:
                    'Erfrischender Komfort: Apartments & Ferienhäuser mit Pool & Klimaanlage',
                  description:
                    'Entdecken Sie Komfort und Kühle in unseren Apartments, die mit Pool und Klimaanlage für einen erholsamen Urlaub ausgestattet sind!',
                },
              },
              sea: {
                reviews: {
                  title: 'Entspannung am Meer: Top-Unterkünfte am Meer',
                  description:
                    'Genießen Sie die Annehmlichkeiten unserer erstklassigen Ferienunterkünfte am Meer  und damit eine unvergessliche Auszeit!',
                },
                sustainable: {
                  title:
                    'Umweltfreundlicher Urlaub am Meer: nachhaltige Ferienhäuser in Strandnähe',
                  description:
                    'Genießen Sie umweltfreundliches Wohnen in unseren nachhaltigen Unterkünften in Meeresnähe und verbinden Sie Komfort mit dem Schutz der Natur!',
                },
                wlan: {
                  title: 'Ferienunterkünfte am Meer mit WiFi ',
                  description:
                    'Bleiben Sie in Verbindung in unseren Ferienhäusern am Meer und nutzen Sie das Highspeed-WiFi für einen entspannten Urlaub!',
                },
                parking: {
                  title: 'Ferienhäuser am Meer mit Parkplatz',
                  description:
                    'Erholen Sie sich unseren Ferienunterkünften am Meer mit unvergleichlicher Aussicht und eigenem Parkplatz.',
                },
                aircondition: {
                  title: 'Ferienhäuser am Meer mit Klimaanlage',
                  description:
                    'Erleben Sie die erfrischende Meeresbrise und eine angenehme Kühle in unseren klimatisierten Ferienwohnungen am Meer.',
                },
              },
              pets: {
                reviews: {
                  title:
                    'Hundeparadies: Top-bewertete Ferienhäuser für Ihre Fellnasen',
                  description:
                    'Ihr haustierfreundliches Paradies erwartet Sie in unseren top-bewerteten Ferienunterkünften, die perfekt auf Urlaub mit Hund zugeschnitten sind.',
                },
                sustainable: {
                  title:
                    'Grüner Urlaub: Nachhaltige Ferienhäuser für Ihren Urlaub mit Hund ',
                  description:
                    'Teilen Sie den umweltfreundlichen Komfort mit Ihrem Hund in unseren nachhaltigen Ferienhäusern und genießen Sie die harmonische Verbindung von Natur und Wohlbefinden.',
                },
                wlan: {
                  title: 'Perfekte hundefreundliche Unterkünfte mit WiFi',
                  description:
                    'Bleiben Sie in Verbindung in unseren erstklassigen, hundefreundlichen Ferienhäusern, die Komfort mit Highspeed-WiFi verbinden.',
                },
                parking: {
                  title: 'Hundefreundliche Unterkünfte mit Parkmöglichkeit',
                  description:
                    'Freuen Sie sich auf unsere hundefreundlichen Apartments und Ferienhäuser mit großzügigen Parkplätzen für einen komfortablen Aufenthalt.',
                },
                hiking: {
                  title:
                    'Hundefreundliche Apartments & Ferienhäuser für Wanderabenteuer',
                  description:
                    'Entdecken Sie unsere hundefreundlichen Ferienunterkünfte, ideal gelegen für unvergessliche Wanderabenteuer mit Hund.',
                },
              },
              skiing: {
                reviews: {
                  title: 'Top-bewertete Unterkünfte für Skiurlaub',
                  description:
                    'Genießen Sie den Winterspaß mit unseren top-bewerteten Ferienunterkünften, perfekt gelegen für Ihren unvergesslichen Skiurlaub.',
                },
                sustainable: {
                  title:
                    'Umweltfreundliche Rückzugsorte: nachhaltige Ferienhäuser für den Skiurlaub',
                  description:
                    'Wählen Sie für Ihre Skiabenteuer unsere nachhaltigen Ferienhäuser, wo umweltfreundliches Wohnen auf alpine Gemütlichkeit trifft!',
                },
                wlan: {
                  title:
                    'Bleiben Sie in Verbindung: perfekte Ferienhäuser für den Skiurlaub mit WiFi',
                  description:
                    'Bleiben Sie im Skiurlaub in Verbindung in unseren perfekten, mit High-Speed-WiFi ausgestatteten Ferienunterkünften.',
                },
                fireplace: {
                  title:
                    'Winterkomfort: Wohnungen & Chalets mit gemütlichem Kamin',
                  description:
                    'Ausgestattet mit gemütlichem Kamin bieten Ihnen unsere Apartments & Chalets im Skigebiet eine perfekte Winterauszeit.',
                },
                cheapcheap: {
                  title:
                    'Erschwingliche Skigebiete: günstige Ferienwohnungen und Ferienhäuser',
                  description:
                    'Erleben Sie erschwinglichen Komfort in unseren preisgünstigen Ferienwohnungen und Ferienhäusern, ideal gelegen für aufregende Skiabenteuer.',
                },
              },
              familyfriendly: {
                reviews: {
                  title: 'Top-bewertete familienfreundliche Unterkünfte',
                  description:
                    'Freuen Sie sich auf einen unvergesslichen Familienurlaub und wählen Sie eine der top-bewerteten, familienfreundlichen Unterkünfte  für Ihre nächste Auszeit aus.',
                },
                sustainable: {
                  title:
                    'Zeit für eine umweltbewusste Auszeit: nachhaltige und familienfreundliche Ferienhäuser',
                  description:
                    'Entdecken Sie umweltfreundliche und familienfreundliche Ferienhäuser, die Nachhaltigkeit mit Entspannung verbinden und Ihrer Familie damit eine umweltbewusstere Möglichkeit bieten, den Urlaub zu genießen.',
                },
                wlan: {
                  title:
                    'Bleiben Sie in Verbindung: perfekte Unterkünfte für Ihren Familienurlaub mit WiFi',
                  description:
                    'Genießen Sie Ihren Urlaub in familienfreundlichen Unterkünften. Ausgestattet mit WiFi bleiben Kinder und Erwachsene hier in Verbindung',
                },
                parking: {
                  title:
                    'Entdecken Sie familienfreundliche Ferienhäuser mit bequemen Parkmöglichkeiten',
                  description:
                    'Starten Sie entspannt in den Urlaub mit diesen einladenden Familienunterkünften. Sie bieten bequeme Parkmöglichkeiten und sorgen somit für einen stressfreien und angenehmen Aufenthalt.',
                },
                aircondition: {
                  title:
                    'Erfrischender Komfort: Familienfreundliche Ferienwohnungen & Ferienhäuser mit Klimaanlage',
                  description:
                    'Mit unseren familienfreundlichen Ferienwohnungen mit Klimaanlage bewahren Sie einen kühlen Kopf und können Ihren Urlaub rundum genießen.',
                },
              },
            },
          },
          content: {
            WeatherInfo: {
              hr_s: '{count} Std. | {count} Std. | {count} Std.',
              day_s: '{count} Tage | {count} Tag | {count} Tage',
              min: 'min. {value}°',
              max: 'max. {value}°',
            },
            SightsAndContent: {
              showMore: 'Mehr anzeigen', // 16989"
              introHeading: 'Entdecke Urlaubsziel {destination}', // 42537
            },
          },
          SearchFilterSelect: {
            more: 'Mehr',
          },
        },
        start: {
          StartHolidayIdeas: {
            title: 'Urlaubsideen',
            subtitle:
              'Urlaubsideen entdecken - stöbern Sie durch unsere große Auswahl an Ferienunterkünften',
            button: 'Alle Urlaubsideen anzeigen',
          },
          StartRecommendations: {
            title: 'Empfehlungen für Sie',
            subtitle:
              'Genießen Sie Ihre Auszeit in Ihrer persönlichen Traum-Ferienunterkunft',
          },
          StartTopDestinations: {
            allCountries: 'Alle Reiseländer im Überblick',
            countries: 'Top Länder',
            regions: 'Top Regionen',
          },
        },
        PageHome: {
          searchTeaser: 'Beliebte Reiseziele & Urlaubsideen',
        },
        PageContent: {
          menu: 'Menu',
        },
        PageReviews: {
          userReviews: 'Kundenbewertungen',
          guaranteedGenuine: 'Garantiert echt',
          guaranteedGenuineText:
            'Nur Kunden, die tatsächlich in einer Interhome Unterkunft ihren Urlaub verbracht haben, können auch eine Bewertung für diese Unterkunft abgeben. Dazu bekommen unsere Kunden nach ihrer Rückreise eine E-Mail mit einem individuellen Link gesendet, der zum passenden Bewertungsformular führt.',
        },
      },
      common: {
        Chatbot: {
          header: 'Wie kann ich Ihnen helfen?',
          introduction:
            'Ich bin Ihr digitaler Chat-Assistent und unterstütze Sie rund um die Uhr bei Ihren Fragen. Hier geht es zu unseren <a href="{link}" target="_blank">Datenschutzhinweisen</a>.',
          placeholder: 'Nachricht hier eingeben...',
          sending: 'Wird gesendet...',
          delivered: 'Gesendet',
          days: 'vor {value} Tag(en)',
          hours: 'vor {value} Std.',
          minutes: 'vor {value} Min.',
          now: 'Gerade eben',
          send: 'Senden',
        },
      },
      topCountries: {
        headline: 'Top Länder',
        countries: 'Alle Reiseländer im Überblick',
        ideas: 'Alle Urlaubsideen anschauen',
      },
      ui: {
        interhomePopup: {
          header: 'Aus der Marke Interchalet wird Interhome!',
          subheader: 'Neues Aussehen, gleiches Angebot!  ',
          text: 'Außer dem Namen ändert sich nichts. Neugierig? Dann schauen Sie gerne vorbei.',
          textAfter:
            'Finden heute Ihr perfektes Ferienhaus!Sie wie bisher die gleichen Interchalet Ferienhäuser unter einem anderen Namen. Buchen Sie noch',
          more: 'Mehr anzeigen',
          moreAfter: 'Mehr lesen',
          cancel: 'Abbrechen',
        },
        alert: {
          note: 'Hinweis',
          importantNote: 'Wichtiger Hinweis',
          importantObjectNote: 'Wichtiger Hinweis zu diesem Objekt',
        },
        BookingTeaser: {
          completeBooking: 'Buchung abschließen',
          pax_s: 'keine Person | eine Person | {count} Personen',
        },
        ExpandableContent: {
          showMore: 'Mehr zeigen',
          showLess: 'Weniger zeigen',
        },
        WebccOrDivider: {
          or: 'or',
        },
      },
    },
    pages: {
      emails: {
        _hash: {
          optin: {
            title: 'Anmeldebestätigung',
            success: {
              heading: 'Ihre Anmeldung war erfolgreich.',
              text: 'Sie können sich nun weiter umsehen.',
            },
            error: {
              heading: 'Leider ist bei der Bestätigung ein Fehler aufgetreten.',
              text: 'TODO: Hier sollte Text zum nächsten Schritt folgen',
            },
            recommendations: 'Unsere Empfehlungen',
          },
          unsubscribe: {
            title: 'Newsletter Abmeldung',
            heading:
              'Ihre Abmeldung ist fast abgeschlossen. Würden Sie uns verraten, warum Sie keinen Newsletter mehr von uns erhalten möchten?',
            options: {
              noreason: 'Ich möchte keine Angaben machen',
              frequency: 'Newsletter kommt zu oft',
              topics: 'Themenwahl entspricht nicht meiner Vorstellung',
              needs:
                'Ferienhäuser/-wohnungen entsprechen nicht meinen Bedürfnissen',
              newsletters: 'Ich erhalte generell zu viele Newsletter',
            },
            submit: 'Jetzt abmelden',
            success: {
              heading: 'Ihre Newsletter-Abmeldung war erfolgreich',
              text: 'Sie können sich nun weiter umsehen.',
            },
            error: {
              heading: 'Leider ist  ein Fehler aufgetreten.',
              note: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt nochmal.',
              button: 'Zurück zur Abmeldung',
            },
            recommendations: 'Unsere Empfehlungen',
          },
          confirm: {
            title: 'E-Mail-Bestätigung',
            success: {
              heading:
                'Ihre E-Mail-Adresse konnte erfolgreich bestätigt werden',
              text: 'Sie können sich nun weiter umsehen.',
            },
            error: {
              heading:
                'Leider ist bei der Bestätigung Ihrer E-Mail-Adresse ein Fehler aufgetreten',
              text: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt nochmal.',
            },
            recommendations: 'Unsere Empfehlungen',
          },
        },
      },
      newsletter: {
        error:
          'Leider ist ein Fehler aufgetreten. Versuchen Sie es bitte später nochmals.',
        emailError: 'Bitte geben Sie eine gültige E-Mail Adresse an',
        title: 'Newsletter',
        sub: 'Ab sofort nichts mehr verpassen!',
        orderText:
          'Möchten Sie gerne regelmäßig über Aktionen, Neuigkeiten und besondere Angebote informiert werden? Dann abonnieren Sie jetzt unseren Newsletter.',
        orderUnsubscribePossible:
          'Sie können ihn jederzeit wieder abbestellen.',
        gdpr: 'Wir verwenden Ihre eMail Adresse, Anrede sowie Vor- und Nachnamen auf Grundlage von Art. 6 Abs. f, DSGVO zum Zweck der Zusendung des mit diesem Formular bestellten Newsletters und zur Zusendung weiterer Informationen zu unserem Angebot. Weitere Informationen nach Art. 13 DSGVO finden Sie in unserer {dse}.',
        privacyPolicy: 'Datenschutzerklärung',
        submit: 'Absenden',
        salutation: 'Anrede',
        firstname: 'Vorname',
        lastname: 'Nachname',
        email: 'E-Mail',
        mr: 'Herr',
        ms: 'Frau',

        success: {
          heading: 'Vielen Dank für Ihre Anmeldung',
          transmission: 'Ihre Daten wurden erfolgreich übermittelt.',
          continue:
            'Sie erhalten in Kürze eine E-Mail, um die angegebene E-Mail-Adresse zu bestätigen.',
          inspiration: 'Weiter zur Startseite',
        },
        recommendations: 'Unsere Empfehlungen',
      },
      favorites: {
        title: 'Merkliste',
        loading: 'Daten werden geladen',
        noList: 'Sie haben noch keine Objekte auf Ihre Merkliste gesetzt.',
        filters: 'Liste filtern',
        close: 'Schließen',
        options: 'Weitere Optionen',
        sorting: {
          heading: 'Sortierung',
          age: 'Neueste zuerst',
          rating: 'Kundenbewertungen',
          paxAsc: 'Anzahl Personen (aufsteigend)',
          paxDesc: 'Anzahl Personen (absteigend)',
          priceAsc: 'Preis (aufsteigend)',
          priceDesc: 'Preis (absteigend)',
        },
        removeAll:
          'Sind Sie sicher, dass Sie alle Elemente von Ihrer Merkliste entfernen wollen?',
        notAvailable: 'Das Objekt {accomId} ist leider nicht mehr verfügbar.',
      },
    },
  },
  components: {
    cookieConsent: {
      cookiesAccept: 'Akzeptieren',
      cookiesAcceptAll: 'Alle akzeptieren',
      cookiesAnalyticalText:
        'Die statistische Analyse Ihres Besuchs auf unserer Webseite hilft uns, die Webseite für Sie zu verbessern. Dazu werden Cookies gesetzt, die eine solche Analyse technisch ermöglichen.',
      cookiesAnalyticalTitle: 'Analytische Cookies',
      cookiesConfigureLink: 'Konfigurieren',
      cookiesConfirmChoice: 'Auswahl speichern',
      cookiesDecline: 'Ablehnen',
      cookiesFunctionalText:
        'Einige technische Grundfunktionen dieser Webseite basieren auf dem Einsatz von Cookies. Dort speichern wir zum Beispiel Ihre Merkliste oder die von Ihnen bevorzugte Währung.',
      cookiesFunctionalTitle: 'Funktionale Cookies (immer aktiv)',
      cookiesInfotextBefore:
        'Wir nutzen Cookies, um eine optimale Funktionalität und personalisierte Inhalte zu bieten. Mit "Akzeptieren" stimmen Sie der Nutzung zu. Alternativ können Sie die Cookie-Einstellungen anpassen. Weitere Infos zum Datenschutz finden Sie',
      cookiesManagePreferences: 'Bitte wählen Sie Ihre Einstellung',
      cookiesMarketingText:
        'Durch das Setzen von Marketing Cookies können unsere Marketing- und Werbepartner Ihnen auch auf anderen Seiten persönlich auf Sie zugeschnittene Angebote zeigen.',
      cookiesMarketingTitle: 'Marketing Cookies',
      cookiesMoreInfoAfter: '.',
      cookiesMoreInfoHere: 'hier',
      cookiesSettings: 'Cookie Einstellungen',
      cookiesTitle: 'Wir gehen sorgfältig mit Ihren Daten um',
    },
  },
  plugins: {
    components: {
      GeneralInfobar: {
        text: 'From <strong>Friday 13th December 2024</strong> to <strong>Sunday 15th December 2024</strong>, bookings will not be possible on our website. We are updating our systems to provide you with an even better booking experience in the future. Thank you for your understanding!',
      },
      B2BInfobar: {
        id: 'Ihre PartnerID',
        logout: 'Logout',
        portal: 'Partner Home',
      },
      FreeCancellationInfo: {
        title: 'Aktion', //
        text: 'kostenlose Stornierung bis', //
        tooltipTitle: 'Kostenlose Stornierung möglich', //
        tooltipText:
          'Bis {date} können Sie kostenlos stornieren und erhalten den gezahlten Betrag erstattet. Diese Regelung gilt nur für Anreisetermine, die mehr als 60 Tage in der Zukunft liegen. Für alle übrigen Reisetermine gelten die untenstehenden Stornobedingungen.', //
        short: 'Free cancellation',
      },
    },
    form: {
      Formfield: {
        forbiddenChars: "Bitte verwenden Sie die Zeichen <>' nicht.",
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse an',
        maxlen40: 'Nur weniger als 40 Zeichen erlaubt',
        maxlen500: 'max. 500 Zeichen für Fragen und Sonderwünsche',
        maxlen80: 'Nur weniger als 80 Zeichen erlaubt',
        phoneValidation:
          'Bitte gültige Telefonnummer eingeben (nur Ziffern - z.b. 0442101010)',
        required: 'Bitte ausfüllen',
        requiredInfo: '*=Angabe erforderlich',
        unmatchedPattern: "Bitte verwenden Sie die Zeichen <>' nicht.",
      },
    },
  },
  errors: {
    title: 'Ein Fehler ist aufgetreten',
    messages: {
      internal:
        'Es ist ein interner Fehler aufgetreten. Bitte versuchen Sie es in einigen Minuten erneut. Wenn der Fehler weiterhin besteht, wenden Sie sich an unsere Sevice Hotline.',
      invalidToken:
        'Das übergebene Token ist ungültig. Bitte prüfen Sie, ob die eingegebene URL mit der URL übereinstimmt, die Sie per E-Mail erhalten haben. Sollte dies der Fall sein, ist der Zugriff auf die Buchungsverwaltung derzeit nicht möglich. Bitte nehmen Sie in diesem Fall telefonisch Kontakt mit uns auf.',
      notFound:
        'Die von Ihnen aufgerufene Seite konnte leider nicht gefunden werden.',
    },
  },
}

export default translations

export type { translations as TranslationsType }

export type RecursiveKeyOf<TObj extends object> = {
  [TKey in keyof TObj & (string | number)]: RecursiveKeyOfHandleValue<
    TObj[TKey],
    `${TKey}`
  >
}[keyof TObj & (string | number)]

type RecursiveKeyOfInner<TObj extends object> = {
  [TKey in keyof TObj & (string | number)]: RecursiveKeyOfHandleValue<
    TObj[TKey],
    `.${TKey}`
  >
}[keyof TObj & (string | number)]

type RecursiveKeyOfHandleValue<
  TValue,
  Text extends string,
> = TValue extends any[]
  ? Text
  : TValue extends object
    ? Text | `${Text}${RecursiveKeyOfInner<TValue>}`
    : Text
